import * as Yup from "yup";

export enum REQUIREMENT_COMPETENCY_TYPE {
  EPA = "EPA",
  DOP = "DOP",
}

export const initialValuesEPA = {
  name: "",
  description: "",
  overview: "",
  min_small_animals_count: 1,
  min_large_animals_count: 1,
  hour: 1,
  minutes: 1,
  min_performance: 1,
  min_score: 1,
};

export const initialValuesITER = {
  name: "",
  description: "",
  min_small_animals_count: 1,
  min_large_animals_count: 1,
  hour: 1,
  minutes: 1,
  min_performance: 1,
  min_score: 1,
};

export const initialValuesCompetency = {
  name: "",
  overview: "",
  description: "",
  requirement_type: REQUIREMENT_COMPETENCY_TYPE.EPA,
  animal_size: "any",
  min_small_animals_count: 0,
  min_large_animals_count: 0,
  hour: 1,
  minutes: 1,
  min_performance: 1,
  min_score: 1,
};

export const validationSchemaEPA = Yup.object().shape({
  name: Yup.string().required("Requirement ID is required"),
  description: Yup.string().required("Description is required"),
  min_small_animals_count: Yup.number().required(),
  min_large_animals_count: Yup.number().required(),
  hour: Yup.number().min(0).required(),
  minutes: Yup.number().min(0).max(59).required(),
  min_performance: Yup.number().required(),
  min_score: Yup.number().required(),
});

export const validationSchemaITER = validationSchemaEPA;

export const validationSchemaCompetency = Yup.object().shape({
  name: Yup.string().required("Requirement Name is required"),
  overview: Yup.string(),
  description: Yup.string(),
  requirement_type: Yup.string().required("Type is required"),
  hour: Yup.number().min(0).required(),
  minutes: Yup.number().min(0).max(59).required(),
  min_performance: Yup.number().required(),
  min_score: Yup.number().required(),
});
